<template>
  <a-badge
    :count="hideCount ? 0 : length"
    :numberStyle="{
      backgroundColor: '#fff',
      color: '#999',
      boxShadow: '0 0 0 1px #e0e0e0 inset'
    }"
  >
    <a
      v-if="hasImages"
      v-lazyload
      @click.prevent="openGallery"
      class="thumbnail"
      :style="sizes"
      href="javascript:void(0);"
    >
      <img
        ref="mainImage"
        :data-url="thumbnailImageUrl"
        @error="handleError"
        alt=""
      />
    </a>

    <span
      class="thumbnail thumbnail--empty"
      :style="sizes"
      v-else
    >
      <img
        :src="thumbnailImageUrl"
        alt=""
      />
    </span>
  </a-badge>
</template>

<script lang="ts" setup>
import { computed, inject, ref, shallowRef, watch } from "vue"

import { getFullImagePath } from "@/utils/cdn"
import imageUrlWrapper from "@/utils/imageUrlWrapper"

type Props = {
  images?: Array<string>
  hideCount?: boolean
  size?: number
}

const props = withDefaults(defineProps<Props>(), {
  images: () => [],
  hideCount: false,
  size: 65
})

const thumbnailSize = shallowRef("300x300")

const showGallery = inject<Function>("showGallery")

const mainImage = ref()

const thumbnailImageUrl = computed<string>(() => {
  if (hasImages.value) {
    const firstImage = props.images[0]
    const isNotCdn = firstImage.includes("://")

    return isNotCdn ? firstImage : getFullImagePath(firstImage, thumbnailSize.value)
  }

  return imageUrlWrapper(null)
})
const length = computed<number>(() => props.images.length)
const hasImages = computed<boolean>(() => Boolean(length.value))

watch(thumbnailImageUrl, (newUrl) => {
  if (mainImage.value?.src && mainImage.value.src !== newUrl) {
    mainImage.value.src = newUrl
  }
})

const sizes = computed(() => {
  return {
    width: `${props.size}px`,
    height: `${props.size}px`,
    minWidth: `${props.size}px`,
    minHeight: `${props.size}px`,
    display: "inline-block"
  }
})

const openGallery = () => {
  if (hasImages.value && showGallery) {
    showGallery({
      images: props.images
    })
  }
}
const handleError = () => {
  thumbnailSize.value = "full"
}
</script>

<style lang="scss" scoped>
.thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;

  &--empty {
    background-color: #e6f7ff;
  }

  & img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
